module.exports = __webpack_public_path__ + "static/media/profile.48948d70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/profile.jpg
// module id = 129
// module chunks = 0